import { render } from "./ApplicationDetails.vue?vue&type=template&id=33794729&ts=true"
import script from "./ApplicationDetails.vue?vue&type=script&lang=ts"
export * from "./ApplicationDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__